/* tslint:disable */
/* eslint-disable */
/**
 * Rever Returns Public API
 * Service for managing Rever returns
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * generic address used in many scenarios
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postcode'?: string;
    /**
     * Unique ID in the rever platform
     * @type {string}
     * @memberof Address
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state_province'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface AddressIssue
 */
export interface AddressIssue {
    /**
     * Carrier whose rule flagged the field.
     * @type {string}
     * @memberof AddressIssue
     */
    'carrier'?: string;
    /**
     * Code is the machine-readable reason, e.g. phone_not_international, postcode_format, state_required.
     * @type {string}
     * @memberof AddressIssue
     */
    'code'?: string;
    /**
     * Confidence is high, medium or low.
     * @type {string}
     * @memberof AddressIssue
     */
    'confidence'?: string;
    /**
     * Field as the return address names it: address_line_1, address_line_2, postcode, state_province_code, country_code, phone or email.
     * @type {string}
     * @memberof AddressIssue
     */
    'field'?: string;
    /**
     * SuggestedValue is the corrected value when the fix is mechanical. An empty string clears the field. Absent when the shopper has to retype the value.
     * @type {string}
     * @memberof AddressIssue
     */
    'suggested_value'?: string;
}
/**
 * 
 * @export
 * @interface AddressSuggestion
 */
export interface AddressSuggestion {
    /**
     * 
     * @type {string}
     * @memberof AddressSuggestion
     */
    'city'?: string;
    /**
     * Confidence is high, medium or low.
     * @type {string}
     * @memberof AddressSuggestion
     */
    'confidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressSuggestion
     */
    'postcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressSuggestion
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface CalculateRefundMethodsRequest
 */
export interface CalculateRefundMethodsRequest {
    /**
     * 
     * @type {string}
     * @memberof CalculateRefundMethodsRequest
     */
    'checkout_id': string;
    /**
     * 
     * @type {Array<ExchangeSelection>}
     * @memberof CalculateRefundMethodsRequest
     */
    'exchange_selections'?: Array<ExchangeSelection>;
    /**
     * 
     * @type {Array<ItemToReturn>}
     * @memberof CalculateRefundMethodsRequest
     */
    'items_to_return': Array<ItemToReturn>;
    /**
     * 
     * @type {string}
     * @memberof CalculateRefundMethodsRequest
     */
    'language'?: string;
    /**
     * 
     * @type {Address}
     * @memberof CalculateRefundMethodsRequest
     */
    'return_address'?: Address;
}
/**
 * 
 * @export
 * @interface CalculateRefundMethodsResponse
 */
export interface CalculateRefundMethodsResponse {
    /**
     * 
     * @type {Array<OrderedItem>}
     * @memberof CalculateRefundMethodsResponse
     */
    'ordered_items'?: Array<OrderedItem>;
    /**
     * 
     * @type {CalculatedRefundMethods}
     * @memberof CalculateRefundMethodsResponse
     */
    'result'?: CalculatedRefundMethods;
    /**
     * 
     * @type {string}
     * @memberof CalculateRefundMethodsResponse
     */
    'result_raw'?: string;
}
/**
 * 
 * @export
 * @interface CalculateRequest
 */
export interface CalculateRequest {
    /**
     * Checkout ID of the initiated checkout
     * @type {string}
     * @memberof CalculateRequest
     */
    'checkout_id': string;
    /**
     * address where the items have to be dropped off
     * @type {Address}
     * @memberof CalculateRequest
     */
    'drop_off_address'?: Address;
    /**
     * exchanges selected by the user
     * @type {Array<ExchangeSelection>}
     * @memberof CalculateRequest
     */
    'exchange_selections'?: Array<ExchangeSelection>;
    /**
     * address where to send the exchanged items
     * @type {Address}
     * @memberof CalculateRequest
     */
    'exchange_shipping_address'?: Address;
    /**
     * Whether the customer selected instant exchange
     * @type {boolean}
     * @memberof CalculateRequest
     */
    'is_exchange_instant'?: boolean;
    /**
     * Items to be returned V2
     * @type {Array<ItemToReturn>}
     * @memberof CalculateRequest
     */
    'items_to_return': Array<ItemToReturn>;
    /**
     * Keep your item selected
     * @type {boolean}
     * @memberof CalculateRequest
     */
    'keep_your_item_selected'?: boolean;
    /**
     * address where the items have to be picked up
     * @type {Address}
     * @memberof CalculateRequest
     */
    'pickup_address'?: Address;
    /**
     * pickup ranges when the customer is available for pickup
     * @type {Array<PickupRange>}
     * @memberof CalculateRequest
     */
    'pickup_ranges'?: Array<PickupRange>;
    /**
     * Refund method chosen by the user
     * @type {RefundPaymentMethod}
     * @memberof CalculateRequest
     */
    'refund_method'?: RefundPaymentMethod;
    /**
     * Return method
     * @type {ReturnMethod}
     * @memberof CalculateRequest
     */
    'return_method'?: ReturnMethod;
    /**
     * User preferred language (es, es-ES, en, en-GB...) the backend might not support every language and there is a default fallback
     * @type {string}
     * @memberof CalculateRequest
     */
    'user_preferred_lang'?: string;
    /**
     * What logistics carrier the user selected along with the ReturnMethod. The options were listed in the get_return_methods call
     * @type {string}
     * @memberof CalculateRequest
     */
    'user_selected_carrier'?: string;
    /**
     * What logistics Provider the user selected along with the ReturnMethod
     * @type {string}
     * @memberof CalculateRequest
     */
    'user_selected_provider'?: string;
}


/**
 * 
 * @export
 * @interface CalculateResponse
 */
export interface CalculateResponse {
    /**
     * 
     * @type {CalculatedSummary}
     * @memberof CalculateResponse
     */
    'calculated_summary'?: CalculatedSummary;
    /**
     * 
     * @type {SignedReturnSummary}
     * @memberof CalculateResponse
     */
    'signed_summary'?: SignedReturnSummary;
    /**
     * 
     * @type {string}
     * @memberof CalculateResponse
     */
    'signed_summary_raw'?: string;
}
/**
 * 
 * @export
 * @interface CalculatedRefundMethods
 */
export interface CalculatedRefundMethods {
    /**
     * 
     * @type {FraudResult}
     * @memberof CalculatedRefundMethods
     */
    'fraud_result'?: FraudResult;
    /**
     * 
     * @type {Array<RefundMethod>}
     * @memberof CalculatedRefundMethods
     */
    'refund_methods'?: Array<RefundMethod>;
}
/**
 * Summary of a return process calculated in return-workflow
 * @export
 * @interface CalculatedSummary
 */
export interface CalculatedSummary {
    /**
     * 
     * @type {Array<Cost>}
     * @memberof CalculatedSummary
     */
    'costs'?: Array<Cost>;
    /**
     * 
     * @type {Array<ExchangeItem>}
     * @memberof CalculatedSummary
     */
    'exchange_items'?: Array<ExchangeItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CalculatedSummary
     */
    'is_negative'?: boolean;
    /**
     * 
     * @type {Array<RetItem>}
     * @memberof CalculatedSummary
     */
    'returned_items'?: Array<RetItem>;
    /**
     * 
     * @type {string}
     * @memberof CalculatedSummary
     */
    'subtotal_formatted'?: string;
    /**
     * 
     * @type {string}
     * @memberof CalculatedSummary
     */
    'total_formatted'?: string;
}
/**
 * 
 * @export
 * @interface Cost
 */
export interface Cost {
    /**
     * 
     * @type {string}
     * @memberof Cost
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cost
     */
    'price_formatted'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cost
     */
    'subtype'?: string;
    /**
     * 
     * @type {number}
     * @memberof Cost
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'iso'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'iso_3'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'localname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'nicename'?: string;
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'numcode'?: number;
    /**
     * 
     * @type {number}
     * @memberof Country
     */
    'phonecode'?: number;
}
/**
 * Per-unit package dimensions in centimeters (parcel, not bare product)
 * @export
 * @interface Dimensions
 */
export interface Dimensions {
    /**
     * Package height in whole centimeters (sub-cm precision discarded).
     * @type {number}
     * @memberof Dimensions
     */
    'height_cm'?: number;
    /**
     * Package length in whole centimeters (sub-cm precision discarded).
     * @type {number}
     * @memberof Dimensions
     */
    'length_cm'?: number;
    /**
     * Package width in whole centimeters (sub-cm precision discarded).
     * @type {number}
     * @memberof Dimensions
     */
    'width_cm'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExchangeFlow = {
    ExchangeFlow_NO_EXCHANGE_FLOW: 0,
    ExchangeFlow_OPEN: 1,
    ExchangeFlow_ONE_ON_ONE: 2,
    ExchangeFlow_OPEN_WITH_GIFT_CARD: 3,
    ExchangeFlow_FULL: 4
} as const;

export type ExchangeFlow = typeof ExchangeFlow[keyof typeof ExchangeFlow];


/**
 * 
 * @export
 * @interface ExchangeItem
 */
export interface ExchangeItem {
    /**
     * 
     * @type {string}
     * @memberof ExchangeItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeItem
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeItem
     */
    'price_formatted'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExchangeItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExchangeItem
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExchangeItem
     */
    'variant_name'?: string;
}
/**
 * 
 * @export
 * @interface ExchangeSelection
 */
export interface ExchangeSelection {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExchangeSelection
     */
    'collection_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExchangeSelection
     */
    'line_item_platform_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExchangeSelection
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExchangeSelection
     */
    'signed_product_raw'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeSelection
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface FraudResult
 */
export interface FraudResult {
    /**
     * 
     * @type {number}
     * @memberof FraudResult
     */
    'group'?: number;
    /**
     * 
     * @type {number}
     * @memberof FraudResult
     */
    'outcome'?: number;
    /**
     * 
     * @type {number}
     * @memberof FraudResult
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @interface GetReturnMethodsRequest
 */
export interface GetReturnMethodsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetReturnMethodsRequest
     */
    'checkout_id': string;
    /**
     * 
     * @type {Array<ExchangeSelection>}
     * @memberof GetReturnMethodsRequest
     */
    'exchange_selections'?: Array<ExchangeSelection>;
    /**
     * 
     * @type {Array<ItemToReturn>}
     * @memberof GetReturnMethodsRequest
     */
    'items_to_return': Array<ItemToReturn>;
    /**
     * 
     * @type {boolean}
     * @memberof GetReturnMethodsRequest
     */
    'keep_your_item_selected'?: boolean;
    /**
     * 
     * @type {RefundPaymentMethod}
     * @memberof GetReturnMethodsRequest
     */
    'refund_method'?: RefundPaymentMethod;
    /**
     * Order being returned as strictly received in GetOrder Optional for the moment, will change to required when the frontend is ready
     * @type {Address}
     * @memberof GetReturnMethodsRequest
     */
    'return_address': Address;
    /**
     * 
     * @type {string}
     * @memberof GetReturnMethodsRequest
     */
    'user_preferred_language'?: string;
}


/**
 * 
 * @export
 * @interface GetReturnMethodsResponse
 */
export interface GetReturnMethodsResponse {
    /**
     * 
     * @type {Array<ReturnMethodOption>}
     * @memberof GetReturnMethodsResponse
     */
    'return_methods'?: Array<ReturnMethodOption>;
}
/**
 * 
 * @export
 * @interface ItemToReturn
 */
export interface ItemToReturn {
    /**
     * 
     * @type {RefundAction}
     * @memberof ItemToReturn
     */
    'action': RefundAction;
    /**
     * 
     * @type {string}
     * @memberof ItemToReturn
     */
    'line_item_id': string;
    /**
     * 
     * @type {string}
     * @memberof ItemToReturn
     */
    'product_return_reason': string;
    /**
     * 
     * @type {number}
     * @memberof ItemToReturn
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof ItemToReturn
     */
    'return_reason_comment'?: string;
}


/**
 * 
 * @export
 * @interface KeepYourItem
 */
export interface KeepYourItem {
    /**
     * 
     * @type {boolean}
     * @memberof KeepYourItem
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KeepYourItem
     */
    'force'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof KeepYourItem
     */
    'percentage'?: number;
}
/**
 * 
 * @export
 * @interface LineItemReview
 */
export interface LineItemReview {
    /**
     * Line item ID
     * @type {string}
     * @memberof LineItemReview
     */
    'line_item_id'?: string;
    /**
     * Location ID where the item was restocked
     * @type {string}
     * @memberof LineItemReview
     */
    'location_id'?: string;
    /**
     * Reason in case the review is a Reject
     * @type {string}
     * @memberof LineItemReview
     */
    'reject_reason'?: string;
    /**
     * ID of the review in our system
     * @type {string}
     * @memberof LineItemReview
     */
    'rever_id'?: string;
    /**
     * Should Restock indicates if the item should be restocked in the ecommerce platform
     * @type {boolean}
     * @memberof LineItemReview
     */
    'should_restock'?: boolean;
    /**
     * Show reject reason to the user
     * @type {boolean}
     * @memberof LineItemReview
     */
    'show_reject_reason'?: boolean;
    /**
     * Status of the reviewed item
     * @type {string}
     * @memberof LineItemReview
     */
    'status'?: string;
    /**
     * Time of the review
     * @type {Timestamp}
     * @memberof LineItemReview
     */
    'timestamp'?: Timestamp;
    /**
     * User that completed the review
     * @type {string}
     * @memberof LineItemReview
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface Money
 */
export interface Money {
    /**
     * 
     * @type {string}
     * @memberof Money
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof Money
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface OrderedItem
 */
export interface OrderedItem {
    /**
     * 
     * @type {string}
     * @memberof OrderedItem
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderedItem
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PickupRange = {
    PickupRange_NO_RANGE: 0,
    PickupRange_RANGE_8_TO_12: 1,
    PickupRange_RANGE_12_TO_16: 2,
    PickupRange_RANGE_16_TO_20: 3
} as const;

export type PickupRange = typeof PickupRange[keyof typeof PickupRange];


/**
 * 
 * @export
 * @interface ProcessRequest
 */
export interface ProcessRequest {
    /**
     * BBAN where return the cash without IBAN
     * @type {string}
     * @memberof ProcessRequest
     */
    'bban'?: string;
    /**
     * Checkout id
     * @type {string}
     * @memberof ProcessRequest
     */
    'checkout_id': string;
    /**
     * CountryCode on the refund will be
     * @type {string}
     * @memberof ProcessRequest
     */
    'country_code'?: string;
    /**
     * exchanges selected by the user
     * @type {Array<ExchangeSelection>}
     * @memberof ProcessRequest
     */
    'exchange_selections'?: Array<ExchangeSelection>;
    /**
     * Fraud result
     * @type {FraudResult}
     * @memberof ProcessRequest
     */
    'fraud_result'?: FraudResult;
    /**
     * IBAN where return the cash
     * @type {string}
     * @memberof ProcessRequest
     */
    'iban'?: string;
    /**
     * Items to be returned V2
     * @type {Array<ItemToReturn>}
     * @memberof ProcessRequest
     */
    'items_to_return'?: Array<ItemToReturn>;
    /**
     * SignedRefundMethods string as strictly received in /v1/returns/{ecommerceID}/refund_methods/calculate
     * @type {string}
     * @memberof ProcessRequest
     */
    'signed_refund_methods_raw'?: string;
    /**
     * Signature data as string as strictly received in /v1/returns/{ecommerceID}/calculate
     * @type {string}
     * @memberof ProcessRequest
     */
    'signed_return_summary_raw'?: string;
    /**
     * SWIFT where return the cash without IBAN
     * @type {string}
     * @memberof ProcessRequest
     */
    'swift'?: string;
    /**
     * User preferred language (es, es-ES, en, en-GB...) the backend might not support every language and there is a default fallback
     * @type {string}
     * @memberof ProcessRequest
     */
    'user_preferred_lang'?: string;
}
/**
 * 
 * @export
 * @interface ProcessStartResponse
 */
export interface ProcessStartResponse {
    /**
     * Payment frontend API key
     * @type {string}
     * @memberof ProcessStartResponse
     */
    'payment_frontend_api_key'?: string;
    /**
     * Payment provider
     * @type {string}
     * @memberof ProcessStartResponse
     */
    'payment_provider'?: string;
    /**
     * Payment session ID
     * @type {string}
     * @memberof ProcessStartResponse
     */
    'payment_session_id'?: string;
    /**
     * Return Process ID
     * @type {string}
     * @memberof ProcessStartResponse
     */
    'pid'?: string;
    /**
     * Payment method should be saved
     * @type {boolean}
     * @memberof ProcessStartResponse
     */
    'save_payment_method'?: boolean;
}
/**
 * A product from the e-commerce
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof Product
     */
    'id'?: string;
    /**
     * Images associated to the product
     * @type {Array<ProductImage>}
     * @memberof Product
     */
    'images'?: Array<ProductImage>;
    /**
     * Product name
     * @type {string}
     * @memberof Product
     */
    'name'?: string;
    /**
     * price per unit (following MoneyFormat)
     * @type {number}
     * @memberof Product
     */
    'price'?: number;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof Product
     */
    'sku'?: string;
    /**
     * Optional: product variations if a line-item references a varition, the attributes of the variation have to be used instead of the ones of the product
     * @type {Array<ProductVariant>}
     * @memberof Product
     */
    'variants'?: Array<ProductVariant>;
}
/**
 * An image from the e-commerce catalog
 * @export
 * @interface ProductImage
 */
export interface ProductImage {
    /**
     * Image alternative text
     * @type {string}
     * @memberof ProductImage
     */
    'alt'?: string;
    /**
     * Image name
     * @type {string}
     * @memberof ProductImage
     */
    'name'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof ProductImage
     */
    'src'?: string;
}
/**
 * 
 * @export
 * @interface ProductVariant
 */
export interface ProductVariant {
    /**
     * enabled or disabled
     * @type {boolean}
     * @memberof ProductVariant
     */
    'enabled'?: boolean;
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof ProductVariant
     */
    'id'?: string;
    /**
     * Images associated to the variant
     * @type {Array<ProductImage>}
     * @memberof ProductVariant
     */
    'images'?: Array<ProductImage>;
    /**
     * inventory quantity (only check if inventory_enabled is true)
     * @type {number}
     * @memberof ProductVariant
     */
    'inventory_quantity'?: number;
    /**
     * should be checked before checking quantity
     * @type {boolean}
     * @memberof ProductVariant
     */
    'is_inventory_enabled'?: boolean;
    /**
     * Name of the variant
     * @type {string}
     * @memberof ProductVariant
     */
    'name'?: string;
    /**
     * unit price
     * @type {number}
     * @memberof ProductVariant
     */
    'price'?: number;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof ProductVariant
     */
    'sku'?: string;
}
/**
 * 
 * @export
 * @interface ProvinceData
 */
export interface ProvinceData {
    /**
     * 
     * @type {string}
     * @memberof ProvinceData
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvinceData
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ProvincesResponse
 */
export interface ProvincesResponse {
    /**
     * 
     * @type {Array<ProvinceData>}
     * @memberof ProvincesResponse
     */
    'options'?: Array<ProvinceData>;
}
/**
 * 
 * @export
 * @interface RDVSurplus
 */
export interface RDVSurplus {
    /**
     * 
     * @type {number}
     * @memberof RDVSurplus
     */
    'surplus_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RDVSurplus
     */
    'surplus_percentage'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RefundAction = {
    RefundAction_NO_ACTION: 0,
    RefundAction_TO_EXCHANGE: 1,
    RefundAction_TO_RETURN: 2
} as const;

export type RefundAction = typeof RefundAction[keyof typeof RefundAction];


/**
 * Refund method and timing chosen by the customer
 * @export
 * @interface RefundInfo
 */
export interface RefundInfo {
    /**
     * Refund payment method
     * @type {RefundPaymentMethod}
     * @memberof RefundInfo
     */
    'refund_method'?: RefundPaymentMethod;
    /**
     * When the refund will be triggered
     * @type {RefundTiming}
     * @memberof RefundInfo
     */
    'timing'?: RefundTiming;
}


/**
 * 
 * @export
 * @interface RefundMethod
 */
export interface RefundMethod {
    /**
     * 
     * @type {KeepYourItem}
     * @memberof RefundMethod
     */
    'keep_your_item'?: KeepYourItem;
    /**
     * 
     * @type {RefundPaymentMethod}
     * @memberof RefundMethod
     */
    'method'?: RefundPaymentMethod;
    /**
     * 
     * @type {RDVSurplus}
     * @memberof RefundMethod
     */
    'rdv_surplus'?: RDVSurplus;
    /**
     * 
     * @type {string}
     * @memberof RefundMethod
     */
    'rever_id'?: string;
    /**
     * 
     * @type {Array<ServiceFees>}
     * @memberof RefundMethod
     */
    'service_fee_candidates'?: Array<ServiceFees>;
    /**
     * Deprecated: use ServiceFee instead.
     * @type {ServiceFees}
     * @memberof RefundMethod
     */
    'service_fees'?: ServiceFees;
    /**
     * 
     * @type {ShippingCosts}
     * @memberof RefundMethod
     */
    'shipping_costs'?: ShippingCosts;
    /**
     * 
     * @type {RefundTiming}
     * @memberof RefundMethod
     */
    'timing'?: RefundTiming;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RefundPaymentMethod = {
    RefundPaymentMethod_NO_PAYMENT_METHOD: 0,
    RefundPaymentMethod_BANK_TRANSFER: 1,
    RefundPaymentMethod_ORIGINAL: 2,
    RefundPaymentMethod_PROMO_CODE: 3,
    RefundPaymentMethod_GIFT_CARD: 4,
    RefundPaymentMethod_MANUAL: 5
} as const;

export type RefundPaymentMethod = typeof RefundPaymentMethod[keyof typeof RefundPaymentMethod];


/**
 * 
 * @export
 * @enum {string}
 */

export const RefundTiming = {
    RefundTiming_NO_TIMING: 0,
    RefundTiming_ON_START_RETURN_PROCESS: 1,
    RefundTiming_ON_ITEM_SENT: 2,
    RefundTiming_ON_ITEM_VERIFIED: 3
} as const;

export type RefundTiming = typeof RefundTiming[keyof typeof RefundTiming];


/**
 * 
 * @export
 * @interface RetItem
 */
export interface RetItem {
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'price_formatted'?: string;
    /**
     * 
     * @type {number}
     * @memberof RetItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'return_reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof RetItem
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetItem
     */
    'variant_name'?: string;
}
/**
 * Return method and locations URL chosen by the customer
 * @export
 * @interface ReturnInfo
 */
export interface ReturnInfo {
    /**
     * URL to locate drop-off points or in-store locations (optional)
     * @type {string}
     * @memberof ReturnInfo
     */
    'locations_url'?: string;
    /**
     * Return method
     * @type {ReturnMethod}
     * @memberof ReturnInfo
     */
    'return_method'?: ReturnMethod;
}


/**
 * One of the line items in a return process
 * @export
 * @interface ReturnLineItem
 */
export interface ReturnLineItem {
    /**
     * User action with this item
     * @type {RefundAction}
     * @memberof ReturnLineItem
     */
    'action'?: RefundAction;
    /**
     * Whether this line item contributes to the total_payment_amount charged at checkout
     * @type {boolean}
     * @memberof ReturnLineItem
     */
    'checkout_payment_item'?: boolean;
    /**
     * Return comment
     * @type {string}
     * @memberof ReturnLineItem
     */
    'comment'?: string;
    /**
     * Free-form per-unit attributes propagated from the source platform.
     * @type {Struct}
     * @memberof ReturnLineItem
     */
    'custom_attributes'?: Struct;
    /**
     * Per-unit package dimensions in centimeters (parcel, not bare product), propagated from the order line item. Aggregate by `quantity` for parcel sizing. Optional.
     * @type {Dimensions}
     * @memberof ReturnLineItem
     */
    'dimensions'?: Dimensions;
    /**
     * Id of the line item in the source platform
     * @type {string}
     * @memberof ReturnLineItem
     */
    'id'?: string;
    /**
     * Name of the line item (not necessarily the name of the product)
     * @type {string}
     * @memberof ReturnLineItem
     */
    'name'?: string;
    /**
     * if this line item refers to an item that we need to buy (exchange)
     * @type {boolean}
     * @memberof ReturnLineItem
     */
    'pending_purchase'?: boolean;
    /**
     * Deprecated: Product is nil outside of Workflow
     * @type {Product}
     * @memberof ReturnLineItem
     */
    'product'?: Product;
    /**
     * to get product details, request the product (API)
     * @type {string}
     * @memberof ReturnLineItem
     */
    'product_id'?: string;
    /**
     * URL of the main image of the product/line-item
     * @type {string}
     * @memberof ReturnLineItem
     */
    'product_image_url'?: string;
    /**
     * Reference of the product (usually more human readable than product ID)
     * @type {string}
     * @memberof ReturnLineItem
     */
    'product_reference'?: string;
    /**
     * ProductReturnReason
     * @type {string}
     * @memberof ReturnLineItem
     */
    'product_return_reason'?: string;
    /**
     * number of items of the same product + variant
     * @type {number}
     * @memberof ReturnLineItem
     */
    'quantity'?: number;
    /**
     * User refund payment method
     * @type {RefundPaymentMethod}
     * @memberof ReturnLineItem
     */
    'refund_payment_method'?: RefundPaymentMethod;
    /**
     * Reason why it\'s returned Deprecated
     * @type {ReturnReason}
     * @memberof ReturnLineItem
     */
    'return_reason'?: ReturnReason;
    /**
     * Id of the line item in rever system
     * @type {string}
     * @memberof ReturnLineItem
     */
    'rever_id'?: string;
    /**
     * Reviews of individual items included in the line item
     * @type {Array<LineItemReview>}
     * @memberof ReturnLineItem
     */
    'reviews'?: Array<LineItemReview>;
    /**
     * stock-keeping unit (SKU) is a scannable bar code, most often seen printed on product labels in a retail store
     * @type {string}
     * @memberof ReturnLineItem
     */
    'sku'?: string;
    /**
     * sub total amount of the line following the MoneyFormat of the order before discounts and taxes subtotal = unit_price * quantity
     * @type {number}
     * @memberof ReturnLineItem
     */
    'subtotal'?: number;
    /**
     * Subtype of the item
     * @type {string}
     * @memberof ReturnLineItem
     */
    'subtype'?: string;
    /**
     * total amount of the line following the MoneyFormat of the order including discounts and tax total = (subtotal - total_discounts) + total_taxes this is the amount to be refunded (multiplied by items_returned/quantity)
     * @type {number}
     * @memberof ReturnLineItem
     */
    'total'?: number;
    /**
     * total amount of discounts of the line following the MoneyFormat
     * @type {number}
     * @memberof ReturnLineItem
     */
    'total_discounts'?: number;
    /**
     * total amount of taxes of the line following the MoneyFormat
     * @type {number}
     * @memberof ReturnLineItem
     */
    'total_taxes'?: number;
    /**
     * Return line item type
     * @type {string}
     * @memberof ReturnLineItem
     */
    'type'?: string;
    /**
     * unit price of a single  item (no discounts, no taxes) follows MoneyFormat associated
     * @type {number}
     * @memberof ReturnLineItem
     */
    'unit_price'?: number;
    /**
     * True when the ecommerce\'s upload documents rules ask the customer for photos or documents of this item. Set at checkout.
     * @type {boolean}
     * @memberof ReturnLineItem
     */
    'upload_documents_required'?: boolean;
    /**
     * Variant EAN
     * @type {string}
     * @memberof ReturnLineItem
     */
    'variant_ean'?: string;
    /**
     * variant of the product (same ProductID, different Variant) we are allowing only one variant at the moment (one dimension)
     * @type {string}
     * @memberof ReturnLineItem
     */
    'variant_id'?: string;
    /**
     * Name of the variant
     * @type {string}
     * @memberof ReturnLineItem
     */
    'variant_name'?: string;
    /**
     * Reference of the variant (usually more human readable than variant ID)
     * @type {string}
     * @memberof ReturnLineItem
     */
    'variant_reference'?: string;
    /**
     * Per-unit weight in grams (NOT total line weight). Multiply by `quantity` for the full line weight. Propagated from OrderLineItem.weight.
     * @type {number}
     * @memberof ReturnLineItem
     */
    'weight'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReturnMethod = {
    ReturnMethod_NO_RETURN_METHOD: 0,
    ReturnMethod_HOME_PICK_UP: 1,
    ReturnMethod_DROP_OFF_POINT: 2,
    ReturnMethod_DELIVERY_PICKUP: 3,
    ReturnMethod_IN_STORE: 4
} as const;

export type ReturnMethod = typeof ReturnMethod[keyof typeof ReturnMethod];


/**
 * 
 * @export
 * @interface ReturnMethodOption
 */
export interface ReturnMethodOption {
    /**
     * 
     * @type {string}
     * @memberof ReturnMethodOption
     */
    'carrier'?: string;
    /**
     * 
     * @type {Money}
     * @memberof ReturnMethodOption
     */
    'costs'?: Money;
    /**
     * 
     * @type {string}
     * @memberof ReturnMethodOption
     */
    'drop_off_point_url'?: string;
    /**
     * 
     * @type {ReturnMethod}
     * @memberof ReturnMethodOption
     */
    'name'?: ReturnMethod;
    /**
     * What the shipping would cost without the order\'s WFP free return; set only when that free return brings Costs down to zero.
     * @type {Money}
     * @memberof ReturnMethodOption
     */
    'original_costs'?: Money;
    /**
     * 
     * @type {Array<PickupRange>}
     * @memberof ReturnMethodOption
     */
    'pickup_ranges'?: Array<PickupRange>;
    /**
     * 
     * @type {string}
     * @memberof ReturnMethodOption
     */
    'provider'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReturnReason = {
    /**
    * 
    */
    ReturnReason_NO_RETURN_REASON: 0,
    /**
    * Deprecated
    */
    ReturnReason_WRONG_SIZE: 1,
    /**
    * 
    */
    ReturnReason_WRONG_COLOR: 2,
    /**
    * 
    */
    ReturnReason_NOT_AS_EXPECTED: 3,
    /**
    * 
    */
    ReturnReason_DEFECTIVE: 4,
    /**
    * 
    */
    ReturnReason_CHANGED_MY_MIND: 5,
    /**
    * 
    */
    ReturnReason_WRONG_ITEM: 6,
    /**
    * 
    */
    ReturnReason_WRONG_SIZE_TOO_SMALL: 7,
    /**
    * 
    */
    ReturnReason_WRONG_SIZE_TOO_BIG: 8
} as const;

export type ReturnReason = typeof ReturnReason[keyof typeof ReturnReason];


/**
 * 
 * @export
 * @interface ReturnSummary
 */
export interface ReturnSummary {
    /**
     * Where the order should be dropped off (optional)
     * @type {Address}
     * @memberof ReturnSummary
     */
    'drop_off_address'?: Address;
    /**
     * Exchange flow
     * @type {ExchangeFlow}
     * @memberof ReturnSummary
     */
    'exchange_flow'?: ExchangeFlow;
    /**
     * address where to send the exchanged items (optional)
     * @type {Address}
     * @memberof ReturnSummary
     */
    'exchange_shipping_address'?: Address;
    /**
     * Keep Your Item selected
     * @type {string}
     * @memberof ReturnSummary
     */
    'keep_your_item'?: string;
    /**
     * Items to be returned
     * @type {Array<ReturnLineItem>}
     * @memberof ReturnSummary
     */
    'line_items': Array<ReturnLineItem>;
    /**
     * Where the order should be picked up (optional)
     * @type {Address}
     * @memberof ReturnSummary
     */
    'pickup_address'?: Address;
    /**
     * Pickup ranges when the customer is available for pickup
     * @type {Array<PickupRange>}
     * @memberof ReturnSummary
     */
    'pickup_ranges'?: Array<PickupRange>;
    /**
     * Refund groups the refund method and timing
     * @type {RefundInfo}
     * @memberof ReturnSummary
     */
    'refund'?: RefundInfo;
    /**
     * Return groups the return method and locations URL
     * @type {ReturnInfo}
     * @memberof ReturnSummary
     */
    'return'?: ReturnInfo;
    /**
     * Amount to be paid by the customer (cannot be negative)
     * @type {number}
     * @memberof ReturnSummary
     */
    'total_payment_amount'?: number;
    /**
     * Amount to be refunded to the customer (cannot be negative), excluding exchanges
     * @type {number}
     * @memberof ReturnSummary
     */
    'total_refund_amount'?: number;
    /**
     * What logistics carrier the user selected along with the ReturnMethod. The options were listed in the get_return_methods call
     * @type {string}
     * @memberof ReturnSummary
     */
    'user_selected_carrier'?: string;
    /**
     * What logistics Provider the user selected along with the ReturnMethod
     * @type {string}
     * @memberof ReturnSummary
     */
    'user_selected_provider'?: string;
}


/**
 * 
 * @export
 * @interface ServiceFees
 */
export interface ServiceFees {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceFees
     */
    'apply_only_if_payment_at_checkout'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ServiceFees
     */
    'service_fees_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceFees
     */
    'service_fees_percentage'?: number;
}
/**
 * 
 * @export
 * @interface ShippingCosts
 */
export interface ShippingCosts {
    /**
     * 
     * @type {Money}
     * @memberof ShippingCosts
     */
    'max'?: Money;
    /**
     * 
     * @type {Money}
     * @memberof ShippingCosts
     */
    'min'?: Money;
}
/**
 * A return process  with a signature to verify its contents
 * @export
 * @interface SignedReturnSummary
 */
export interface SignedReturnSummary {
    /**
     * Information about the return summary
     * @type {ReturnSummary}
     * @memberof SignedReturnSummary
     */
    'return_summary'?: ReturnSummary;
    /**
     * Signature of the ReturnSummary field, to prevent tampering
     * @type {string}
     * @memberof SignedReturnSummary
     */
    'signature'?: string;
    /**
     * The identifier of the key used to sign the data
     * @type {string}
     * @memberof SignedReturnSummary
     */
    'signature_key'?: string;
    /**
     * Time of the server / response
     * @type {string}
     * @memberof SignedReturnSummary
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface Struct
 */
export interface Struct {
    /**
     * Unordered map of dynamically typed values.
     * @type {{ [key: string]: Value; }}
     * @memberof Struct
     */
    'fields'?: { [key: string]: Value; };
}
/**
 * 
 * @export
 * @interface Timestamp
 */
export interface Timestamp {
    /**
     * Non-negative fractions of a second at nanosecond resolution. This field is the nanosecond portion of the duration, not an alternative to seconds. Negative second values with fractions must still have non-negative nanos values that count forward in time. Must be between 0 and 999,999,999 inclusive.
     * @type {number}
     * @memberof Timestamp
     */
    'nanos'?: number;
    /**
     * Represents seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z. Must be between -315576000000 and 315576000000 inclusive (which corresponds to 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z).
     * @type {number}
     * @memberof Timestamp
     */
    'seconds'?: number;
}
/**
 * 
 * @export
 * @interface ValidateAddressRequest
 */
export interface ValidateAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateAddressRequest
     */
    'checkout_id': string;
    /**
     * 
     * @type {Array<ItemToReturn>}
     * @memberof ValidateAddressRequest
     */
    'items_to_return': Array<ItemToReturn>;
    /**
     * 
     * @type {RefundPaymentMethod}
     * @memberof ValidateAddressRequest
     */
    'refund_method'?: RefundPaymentMethod;
    /**
     * 
     * @type {Address}
     * @memberof ValidateAddressRequest
     */
    'return_address': Address;
}


/**
 * 
 * @export
 * @interface ValidateAddressResponse
 */
export interface ValidateAddressResponse {
    /**
     * Carrier whose source produced the answer. Empty when unknown.
     * @type {string}
     * @memberof ValidateAddressResponse
     */
    'carrier'?: string;
    /**
     * Issues are fields a carrier would reject over their format, one per field, whatever the status: a phone without the country prefix, a postcode in the wrong shape, a street line that is only a house number.
     * @type {Array<AddressIssue>}
     * @memberof ValidateAddressResponse
     */
    'issues'?: Array<AddressIssue>;
    /**
     * Status is one of: valid, suggestion, not_found, unknown, and speaks about the locality (city, province, postcode). The portal acts on suggestion and on issues; on anything else it carries on as today.
     * @type {string}
     * @memberof ValidateAddressResponse
     */
    'status'?: ValidateAddressResponseStatusEnum;
    /**
     * Suggestions are candidate corrections, best first. Only set when status is suggestion.
     * @type {Array<AddressSuggestion>}
     * @memberof ValidateAddressResponse
     */
    'suggestions'?: Array<AddressSuggestion>;
}

export const ValidateAddressResponseStatusEnum = {
    Valid: 'valid',
    Suggestion: 'suggestion',
    NotFound: 'not_found',
    Unknown: 'unknown'
} as const;

export type ValidateAddressResponseStatusEnum = typeof ValidateAddressResponseStatusEnum[keyof typeof ValidateAddressResponseStatusEnum];

/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
    /**
     * The kind of value.  Types that are valid to be assigned to Kind:   *Value_NullValue  *Value_NumberValue  *Value_StringValue  *Value_BoolValue  *Value_StructValue  *Value_ListValue
     * @type {object}
     * @memberof Value
     */
    'kind'?: object;
}

/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {string} ecommerceID E-commerce ID is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries: async (ecommerceID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('countries', 'ecommerceID', ecommerceID)
            const localVarPath = `/{ecommerceID}/countries`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {string} ecommerceID E-commerce ID is required
         * @param {string} countryCode country code is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinces: async (ecommerceID: string, countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('provinces', 'ecommerceID', ecommerceID)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('provinces', 'countryCode', countryCode)
            const localVarPath = `/{ecommerceID}/countries/{countryCode}/provinces`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {string} ecommerceID E-commerce ID is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countries(ecommerceID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Country>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countries(ecommerceID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.countries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {string} ecommerceID E-commerce ID is required
         * @param {string} countryCode country code is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provinces(ecommerceID: string, countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProvincesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provinces(ecommerceID, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.provinces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Retrieves a list of countries
         * @summary Retrieves a list of countries
         * @param {LocationsApiCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(requestParameters: LocationsApiCountriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Country>> {
            return localVarFp.countries(requestParameters.ecommerceID, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of provinces given a Country Code
         * @summary Retrieves a list of provinces given a Country Code
         * @param {LocationsApiProvincesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provinces(requestParameters: LocationsApiProvincesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProvincesResponse> {
            return localVarFp.provinces(requestParameters.ecommerceID, requestParameters.countryCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for countries operation in LocationsApi.
 * @export
 * @interface LocationsApiCountriesRequest
 */
export interface LocationsApiCountriesRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof LocationsApiCountries
     */
    readonly ecommerceID: string
}

/**
 * Request parameters for provinces operation in LocationsApi.
 * @export
 * @interface LocationsApiProvincesRequest
 */
export interface LocationsApiProvincesRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof LocationsApiProvinces
     */
    readonly ecommerceID: string

    /**
     * country code is required
     * @type {string}
     * @memberof LocationsApiProvinces
     */
    readonly countryCode: string
}

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Retrieves a list of countries
     * @summary Retrieves a list of countries
     * @param {LocationsApiCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public countries(requestParameters: LocationsApiCountriesRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).countries(requestParameters.ecommerceID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of provinces given a Country Code
     * @summary Retrieves a list of provinces given a Country Code
     * @param {LocationsApiProvincesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public provinces(requestParameters: LocationsApiProvincesRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).provinces(requestParameters.ecommerceID, requestParameters.countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RefundMethodsApi - axios parameter creator
 * @export
 */
export const RefundMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {CalculateRefundMethodsRequest} calculateRefundMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundMethods: async (ecommerceID: string, calculateRefundMethodsRequest: CalculateRefundMethodsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('refundMethods', 'ecommerceID', ecommerceID)
            // verify required parameter 'calculateRefundMethodsRequest' is not null or undefined
            assertParamExists('refundMethods', 'calculateRefundMethodsRequest', calculateRefundMethodsRequest)
            const localVarPath = `/{ecommerceID}/refund_methods/calculate`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateRefundMethodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefundMethodsApi - functional programming interface
 * @export
 */
export const RefundMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefundMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {CalculateRefundMethodsRequest} calculateRefundMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundMethods(ecommerceID: string, calculateRefundMethodsRequest: CalculateRefundMethodsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateRefundMethodsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundMethods(ecommerceID, calculateRefundMethodsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RefundMethodsApi.refundMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RefundMethodsApi - factory interface
 * @export
 */
export const RefundMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefundMethodsApiFp(configuration)
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid RefundMethods given the input
         * @param {RefundMethodsApiRefundMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundMethods(requestParameters: RefundMethodsApiRefundMethodsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateRefundMethodsResponse> {
            return localVarFp.refundMethods(requestParameters.ecommerceID, requestParameters.calculateRefundMethodsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for refundMethods operation in RefundMethodsApi.
 * @export
 * @interface RefundMethodsApiRefundMethodsRequest
 */
export interface RefundMethodsApiRefundMethodsRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof RefundMethodsApiRefundMethods
     */
    readonly ecommerceID: string

    /**
     * Body request is required
     * @type {CalculateRefundMethodsRequest}
     * @memberof RefundMethodsApiRefundMethods
     */
    readonly calculateRefundMethodsRequest: CalculateRefundMethodsRequest
}

/**
 * RefundMethodsApi - object-oriented interface
 * @export
 * @class RefundMethodsApi
 * @extends {BaseAPI}
 */
export class RefundMethodsApi extends BaseAPI {
    /**
     * retrieves a list of valid return methods
     * @summary Retrieves a list valid RefundMethods given the input
     * @param {RefundMethodsApiRefundMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundMethodsApi
     */
    public refundMethods(requestParameters: RefundMethodsApiRefundMethodsRequest, options?: RawAxiosRequestConfig) {
        return RefundMethodsApiFp(this.configuration).refundMethods(requestParameters.ecommerceID, requestParameters.calculateRefundMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReturnMethodsApi - axios parameter creator
 * @export
 */
export const ReturnMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {GetReturnMethodsRequest} getReturnMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMethods: async (ecommerceID: string, getReturnMethodsRequest: GetReturnMethodsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('returnMethods', 'ecommerceID', ecommerceID)
            // verify required parameter 'getReturnMethodsRequest' is not null or undefined
            assertParamExists('returnMethods', 'getReturnMethodsRequest', getReturnMethodsRequest)
            const localVarPath = `/{ecommerceID}/get_return_methods`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getReturnMethodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks the captured address against the carriers\' own sources before any method is chosen, so the portal can suggest a fix while the shopper is still there. A carrier that cannot be checked never fails the call: the status is unknown.
         * @summary Validates the return address against the carriers that would ship it
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ValidateAddressRequest} validateAddressRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (ecommerceID: string, validateAddressRequest: ValidateAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('validateAddress', 'ecommerceID', ecommerceID)
            // verify required parameter 'validateAddressRequest' is not null or undefined
            assertParamExists('validateAddress', 'validateAddressRequest', validateAddressRequest)
            const localVarPath = `/{ecommerceID}/validate_address`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReturnMethodsApi - functional programming interface
 * @export
 */
export const ReturnMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReturnMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {string} ecommerceID E-commerce ID is required
         * @param {GetReturnMethodsRequest} getReturnMethodsRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnMethods(ecommerceID: string, getReturnMethodsRequest: GetReturnMethodsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReturnMethodsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnMethods(ecommerceID, getReturnMethodsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnMethodsApi.returnMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks the captured address against the carriers\' own sources before any method is chosen, so the portal can suggest a fix while the shopper is still there. A carrier that cannot be checked never fails the call: the status is unknown.
         * @summary Validates the return address against the carriers that would ship it
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ValidateAddressRequest} validateAddressRequest Body request is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(ecommerceID: string, validateAddressRequest: ValidateAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAddress(ecommerceID, validateAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnMethodsApi.validateAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReturnMethodsApi - factory interface
 * @export
 */
export const ReturnMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReturnMethodsApiFp(configuration)
    return {
        /**
         * retrieves a list of valid return methods
         * @summary Retrieves a list valid ReturnMethods given the input
         * @param {ReturnMethodsApiReturnMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMethods(requestParameters: ReturnMethodsApiReturnMethodsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetReturnMethodsResponse> {
            return localVarFp.returnMethods(requestParameters.ecommerceID, requestParameters.getReturnMethodsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the captured address against the carriers\' own sources before any method is chosen, so the portal can suggest a fix while the shopper is still there. A carrier that cannot be checked never fails the call: the status is unknown.
         * @summary Validates the return address against the carriers that would ship it
         * @param {ReturnMethodsApiValidateAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(requestParameters: ReturnMethodsApiValidateAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateAddressResponse> {
            return localVarFp.validateAddress(requestParameters.ecommerceID, requestParameters.validateAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for returnMethods operation in ReturnMethodsApi.
 * @export
 * @interface ReturnMethodsApiReturnMethodsRequest
 */
export interface ReturnMethodsApiReturnMethodsRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof ReturnMethodsApiReturnMethods
     */
    readonly ecommerceID: string

    /**
     * Body request is required
     * @type {GetReturnMethodsRequest}
     * @memberof ReturnMethodsApiReturnMethods
     */
    readonly getReturnMethodsRequest: GetReturnMethodsRequest
}

/**
 * Request parameters for validateAddress operation in ReturnMethodsApi.
 * @export
 * @interface ReturnMethodsApiValidateAddressRequest
 */
export interface ReturnMethodsApiValidateAddressRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof ReturnMethodsApiValidateAddress
     */
    readonly ecommerceID: string

    /**
     * Body request is required
     * @type {ValidateAddressRequest}
     * @memberof ReturnMethodsApiValidateAddress
     */
    readonly validateAddressRequest: ValidateAddressRequest
}

/**
 * ReturnMethodsApi - object-oriented interface
 * @export
 * @class ReturnMethodsApi
 * @extends {BaseAPI}
 */
export class ReturnMethodsApi extends BaseAPI {
    /**
     * retrieves a list of valid return methods
     * @summary Retrieves a list valid ReturnMethods given the input
     * @param {ReturnMethodsApiReturnMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnMethodsApi
     */
    public returnMethods(requestParameters: ReturnMethodsApiReturnMethodsRequest, options?: RawAxiosRequestConfig) {
        return ReturnMethodsApiFp(this.configuration).returnMethods(requestParameters.ecommerceID, requestParameters.getReturnMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks the captured address against the carriers\' own sources before any method is chosen, so the portal can suggest a fix while the shopper is still there. A carrier that cannot be checked never fails the call: the status is unknown.
     * @summary Validates the return address against the carriers that would ship it
     * @param {ReturnMethodsApiValidateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnMethodsApi
     */
    public validateAddress(requestParameters: ReturnMethodsApiValidateAddressRequest, options?: RawAxiosRequestConfig) {
        return ReturnMethodsApiFp(this.configuration).validateAddress(requestParameters.ecommerceID, requestParameters.validateAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReturnsApi - axios parameter creator
 * @export
 */
export const ReturnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {CalculateRequest} calculateData Calculate data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate: async (ecommerceID: string, calculateData: CalculateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('calculate', 'ecommerceID', ecommerceID)
            // verify required parameter 'calculateData' is not null or undefined
            assertParamExists('calculate', 'calculateData', calculateData)
            const localVarPath = `/{ecommerceID}/calculate`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ProcessRequest} processData Return data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        process: async (ecommerceID: string, processData: ProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceID' is not null or undefined
            assertParamExists('process', 'ecommerceID', ecommerceID)
            // verify required parameter 'processData' is not null or undefined
            assertParamExists('process', 'processData', processData)
            const localVarPath = `/{ecommerceID}/process`
                .replace(`{${"ecommerceID"}}`, encodeURIComponent(String(ecommerceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReturnsApi - functional programming interface
 * @export
 */
export const ReturnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReturnsApiAxiosParamCreator(configuration)
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {CalculateRequest} calculateData Calculate data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculate(ecommerceID: string, calculateData: CalculateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculate(ecommerceID, calculateData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.calculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {string} ecommerceID E-commerce ID is required
         * @param {ProcessRequest} processData Return data is required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async process(ecommerceID: string, processData: ProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.process(ecommerceID, processData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.process']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReturnsApi - factory interface
 * @export
 */
export const ReturnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReturnsApiFp(configuration)
    return {
        /**
         * Method for calculating the line items and totals of a return process
         * @summary Calculating the amounts of a return process
         * @param {ReturnsApiCalculateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(requestParameters: ReturnsApiCalculateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateResponse> {
            return localVarFp.calculate(requestParameters.ecommerceID, requestParameters.calculateData, options).then((request) => request(axios, basePath));
        },
        /**
         * Method for starting a return process given the return summary
         * @summary Start a return process
         * @param {ReturnsApiProcessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        process(requestParameters: ReturnsApiProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessStartResponse> {
            return localVarFp.process(requestParameters.ecommerceID, requestParameters.processData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculate operation in ReturnsApi.
 * @export
 * @interface ReturnsApiCalculateRequest
 */
export interface ReturnsApiCalculateRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof ReturnsApiCalculate
     */
    readonly ecommerceID: string

    /**
     * Calculate data is required
     * @type {CalculateRequest}
     * @memberof ReturnsApiCalculate
     */
    readonly calculateData: CalculateRequest
}

/**
 * Request parameters for process operation in ReturnsApi.
 * @export
 * @interface ReturnsApiProcessRequest
 */
export interface ReturnsApiProcessRequest {
    /**
     * E-commerce ID is required
     * @type {string}
     * @memberof ReturnsApiProcess
     */
    readonly ecommerceID: string

    /**
     * Return data is required
     * @type {ProcessRequest}
     * @memberof ReturnsApiProcess
     */
    readonly processData: ProcessRequest
}

/**
 * ReturnsApi - object-oriented interface
 * @export
 * @class ReturnsApi
 * @extends {BaseAPI}
 */
export class ReturnsApi extends BaseAPI {
    /**
     * Method for calculating the line items and totals of a return process
     * @summary Calculating the amounts of a return process
     * @param {ReturnsApiCalculateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public calculate(requestParameters: ReturnsApiCalculateRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).calculate(requestParameters.ecommerceID, requestParameters.calculateData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method for starting a return process given the return summary
     * @summary Start a return process
     * @param {ReturnsApiProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public process(requestParameters: ReturnsApiProcessRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).process(requestParameters.ecommerceID, requestParameters.processData, options).then((request) => request(this.axios, this.basePath));
    }
}



